import { jsx } from 'react/jsx-runtime';
import Info from '../../../icon/icons/Info.js';
import { s as styleInject } from '../../../../style-inject.es-1f59c1d0.js';
import 'react';
import '../../../icon/IconWrapper/IconWrapper.js';
import '../../../../tslib.es6-a39f91fc.js';
import '../../../../index-6ea95111.js';

var css_248z = ".style-module_button__3TkNT {\n  padding: 0;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  vertical-align: bottom;\n  border-radius: 12px;\n  width: 24px;\n  height: 24px;\n  transition: all 0.3s ease;\n}\n.style-module_button__3TkNT:hover, .style-module_button__3TkNT:focus {\n  background-color: #f7f7ff;\n}\n.style-module_button__3TkNT:hover svg path, .style-module_button__3TkNT:focus svg path {\n  fill: #b1b0f5;\n}\n.style-module_button__3TkNT svg {\n  transition: all 0.3s ease;\n}\n.style-module_button__3TkNT svg path {\n  fill: #d2d2d8;\n}\n.style-module_button__3TkNT:focus-visible {\n  box-shadow: 0 0 0 2px #8e8cee;\n}";
var styles = {"button":"style-module_button__3TkNT"};
styleInject(css_248z);

var TableInfoButton = function (_a) {
    var onClick = _a.onClick, _b = _a.className, className = _b === void 0 ? '' : _b;
    return (jsx("button", { className: "p-btn--secondary ".concat(styles.button, " ").concat(className), type: "button", "data-testid": "ds-table-info-button", onClick: onClick, "aria-label": "View more information", title: "View more information", children: jsx(Info, { size: 20 }) }));
};

export default TableInfoButton;
//# sourceMappingURL=index.js.map
